import type React from "react";
import { Col, Container } from "../../../../components/Theme/grid";
import type { AssetPosition } from "../../../../kubb";
import { isAsset, isAssetPosition } from "../../../../model/assetPosition.tsx";
import type { Asset } from "../../../../utils/object.tsx";
import AssetDataSelectorUrlQuerySetter from "../AssetDataSelectorUrlQuerySetter";
import AssetTimeSeriesDataGetter, {
  type AssetTimeSeriesDataElementProps,
} from "./AssetTimeSeriesDataGetter.tsx";
import AssetTimeSeriesQualityGetter from "./AssetTimeSeriesQualityGetter.tsx";
import DeviceTimeSeriesDataCsvExportButton from "./DeviceTimeSeriesDataCsvExportButton";
import GenericCharts from "./GenericCharts";
import NewAssetDataSearchStringParser from "./NewAssetDataSearchStringParser.tsx";
import AssetDataQualityChart from "./dataQuality/AssetDataQualityChart.tsx";
import ElectricityMeterCharts from "./electricityMeters/ElectricityMeterCharts";
import HeatMeterCharts from "./heatMeters/HeatMeterCharts";

const MeterTimeSeriesCharts = (props: {
  device: Asset | AssetPosition;
  showDataQualityCharts?: boolean;
}): React.ReactElement => {
  let child = GenericCharts;

  const { showDataQualityCharts = true } = props;
  const assetType = isAsset(props.device)
    ? props.device.asset_type
    : isAssetPosition(props.device)
      ? props.device.asset_position_type
      : "unknown";
  switch (assetType) {
    case "heat_meter":
      child = HeatMeterCharts;
      break;
    case "cooling_meter":
      child = HeatMeterCharts;
      break;
    case "heating_and_cooling_meter":
      child = HeatMeterCharts;
      break;
    case "electricity_meter":
      child = ElectricityMeterCharts;
      break;
  }

  function InnerMeterCharts({
    initialized,
    params,
  }: {
    initialized?: boolean;
    params?: any;
  }): React.ReactElement {
    return (
      <>
        {initialized && (
          <>
            <AssetDataSelectorUrlQuerySetter
              device={props.device}
              params={params}
              showProjection={isAsset(props.device)}
            />
            <AssetTimeSeriesDataGetter device={props.device} params={params}>
              {(innerProps: AssetTimeSeriesDataElementProps) => {
                return (
                  <Container className={"py-2"}>
                    <Col className={"float-right w-full"}>
                      <DeviceTimeSeriesDataCsvExportButton {...innerProps} />
                    </Col>
                    {assetType !== "gateway" &&
                      assetType !== "unknown" &&
                      isAsset(props.device) &&
                      showDataQualityCharts && (
                        <Col>
                          <AssetTimeSeriesQualityGetter
                            device={props.device}
                            searchParams={innerProps.params}
                            render={(props) => (
                              <AssetDataQualityChart {...props} />
                            )}
                          />
                        </Col>
                      )}
                    {child(innerProps)}
                  </Container>
                );
              }}
            </AssetTimeSeriesDataGetter>
          </>
        )}
      </>
    );
  }

  return (
    <NewAssetDataSearchStringParser initialState={{ projection: "parsed" }}>
      <InnerMeterCharts />
    </NewAssetDataSearchStringParser>
  );
};

export default MeterTimeSeriesCharts;
